import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { mockTeamMembers } from '../../services/mockData';

const initialState = {
  teamMembers: [],
  loading: false,
  error: null,
};

// Fetch team members (mocked)
export const fetchTeamMembers = createAsyncThunk(
  'teamMembers/fetchTeamMembers',
  async (_, { rejectWithValue }) => {
    try {
      // Simulate API delay
      await new Promise(resolve => setTimeout(resolve, 500));
      return mockTeamMembers;
    } catch (error) {
      return rejectWithValue('Failed to fetch team members');
    }
  }
);

const teamMembersSlice = createSlice({
  name: 'teamMembers',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTeamMembers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTeamMembers.fulfilled, (state, action) => {
        state.loading = false;
        state.teamMembers = action.payload;
      })
      .addCase(fetchTeamMembers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError } = teamMembersSlice.actions;

export const selectTeamMembers = (state) => state.teamMembers.teamMembers;
export const selectTeamMembersLoading = (state) => state.teamMembers.loading;
export const selectTeamMembersError = (state) => state.teamMembers.error;

export default teamMembersSlice.reducer; 